import './SideBar.css';
import logo from '../../../Images/AES_Logo.svg';
//  import logo from './images/seven-bridge-logo-sm.svg';


import assetssvg from './images/assets.svg';
import portfoliossvg from './images/portfolios.svg';
import investorssvg from './images/investors.svg';
import librarysvg from './images/library.svg';
import reportssvg from './images/reports.svg';
import marketDataSVG from './images/market_data.svg';
//import homeSVG from './images/home.svg'
import menu1 from './images/groups.svg';
import collapseSVG from './images/collapse_side_bar_left.svg'
import userSVG from '../../../Images/user.svg';
import logout from '../../../Images/logout.svg';
import help from '../../../Images/help-circle.svg';
import AESLogo from '../../../Images/AESLogo44x40.png';
import { Link } from 'react-router-dom';
import { useCallback, useEffect } from 'react';
import { useState } from 'react';
import { getLeftMenuSection } from '../../actions/leftMenuAction';
import { useDispatch, useSelector } from "react-redux";
import { UrlPath } from '../../../config/routeConfig';
import { useNavigate } from 'react-router-dom';
import $ from "jquery";
import {
    Sidebar,
    Menu,
    MenuItem,
    SubMenu,
    menuClasses,
} from "react-pro-sidebar";
import { setActiveMenu, setActiveSubMenu } from '../../actions/CommonAction';
import { sbaAxios } from '../../utils/sbaAxios';
import { getCustomSettings, getUserPageAccess ,checkNotificationAccess} from '../../../config/apiConfig';
import { HelpContainer, NotificationContainer } from '../topBar/TopBarComponets';
import { ProfileContainer } from '../topBar/TopBarComponets';
import { useMsal } from "@azure/msal-react";
import { Badge } from 'react-bootstrap';
import { useNotification } from '../../../ContentRoutes';


export const SideBar = ({ menuId }) => {
    function handleMenuClick(menu) {
        console.log('menu clicked: ', menu)
        history(`/${menu}`);
    };

    const CollapseSideBar = useCallback((event) => {
        document.getElementById("sidebar").classList.toggle("active")
    });
    const [menuItems, setMenuItems] = useState([]);
    
    const history = useNavigate();
    const dispatch = useDispatch();
    
    useEffect(() => {
        dispatch(getLeftMenuSection());
    }, []);
    
    menuId && menuId(menuItems);
    const assetLeftDataItems = useSelector(state => state.leftMenu) || [];
    const currentAsset = useSelector(state => state.asset.asset) || {};
    //const Marketdatadetails = useSelector(state =>state.Marketdatadetails.Marketdatadetails) || {};
    useEffect(() => {
        setMenuItems(assetLeftDataItems.leftMenuItems);
    }, [assetLeftDataItems.leftMenuItems]);

    const localAssetId = localStorage.getItem("LocalAssetID");
    localStorage.setItem("LocalAssetID", currentAsset.AssetId || localAssetId || 34172);
    //const localMarketIndexId = localStorage.getItem("LocalMarketIndexID");
    //localStorage.setItem("LocalMarketIndexID", Marketdatadetails.MarketIndexId || localMarketIndexId || 29643);



    const renderChildMenuItems = (childMenuItems, ToggleID, parentMenuName) => {

        if (!childMenuItems || childMenuItems.length === 0) {
            return null;
        }
        return (
            <ul className="collapse nav flex-column leftMenuList" id={ToggleID} data-bs-parent="#menu">
                {childMenuItems.map((childMenuItem) => {
                    const AsetID = localStorage.getItem("LocalAssetID") || 34172;
                    const MktIndexID = localStorage.getItem("LocalMarketIndexID") || 29643;
                    let childUrl;
                    if (childMenuItem.MenuParentId === 2)
                        childUrl = childMenuItem.MenuUrl == parentMenuName ? `/${(childMenuItem.MenuUrl)}` : `/${parentMenuName}/${(childMenuItem.MenuUrl)}/${AsetID}`;
                    else if (childMenuItem.MenuParentId === 6)
                        childUrl = childMenuItem.MenuUrl == parentMenuName ? `/${(childMenuItem.MenuUrl)}` : `/${parentMenuName}/${(childMenuItem.MenuUrl)}/${MktIndexID}`;
                    else
                        childUrl = childMenuItem.MenuUrl == parentMenuName ? `/${(childMenuItem.MenuUrl)}` : `/${parentMenuName}/${(childMenuItem.MenuUrl)}`;

                    if (childMenuItem.LstChildMenu.length > 1) {
                        const MenuUrl = `${parentMenuName}/${childMenuItem.MenuName}`;
                        return (
                            <li key={childMenuItem.MenuId} >
                                <a className="nav-link" href={`#MenuLevl${childMenuItem.MenuId}`} data-bs-toggle="collapse" class="nav-link align-middle dropdown-toggle collapsed" onClick={() => handleMenuClick(MenuUrl)}>
                                    {childMenuItem.MenuName}
                                </a>
                                {renderChildMenuLevelOne(childMenuItem.LstChildMenu, `MenuLevl${childMenuItem.MenuId}`, childMenuItem.MenuName, parentMenuName, childMenuItem.MenuParentId)}
                            </li>
                        )
                    }
                    else {
                        return (
                            <li key={childMenuItem.MenuId} >
                                <Link to={{ pathname: childUrl }} className="nav-link">
                                    {childMenuItem.MenuName}
                                </Link>
                            </li>
                        )
                    }
                })
                }
            </ul>
        );
    };
    const renderChildMenuLevelOne = (childMenuItems, ToggleID, parentMenuName, grandParent, grandParentId) => {

        if (!childMenuItems || childMenuItems.length === 0) {
            return null;
        }
        return (
            <ul className="collapse nav flex-column leftMenuList levelOneMenu" id={ToggleID} data-bs-parent={`${parentMenuName}`}>
                {childMenuItems.map((childMenuItem) => {
                    const AsetID = localStorage.getItem("LocalAssetID") || 34172;
                    if (grandParentId === 2) {
                        const childUrl = childMenuItem.MenuUrl == parentMenuName ? `/${(childMenuItem.MenuUrl)}` : `${grandParent}/${parentMenuName}/${(childMenuItem.MenuUrl)}/${AsetID}`;
                        return (
                            <li key={childMenuItem.MenuId} >
                                <Link to={{ pathname: childUrl }} className="nav-link ">
                                    {childMenuItem.MenuName}
                                </Link>
                            </li>
                        )
                    }
                    else {
                        const childUrl = childMenuItem.MenuUrl == parentMenuName ? `/${(childMenuItem.MenuUrl)}` : `${grandParent}/${parentMenuName}/${(childMenuItem.MenuUrl)}`;
                        return (
                            <li key={childMenuItem.MenuId} >
                                <Link to={{ pathname: childUrl }} className="nav-link">
                                    {childMenuItem.MenuName}
                                </Link>
                            </li>
                        )
                    }
                })
                }
            </ul>
        );
    };

    return (
        <nav id="sidebar" className="d-md-block sidebar collapse">
            <div className="position-sticky sidebar-sticky d-flex flex-column flex-shrink-0">
                <div className="sidebar-header">
                    <h3><img src={logo} alt="" /></h3>
                    <strong><img src={logo} alt="" /></strong>
                </div>
                <ul className="nav nav-pills flex-column mb-auto align-items-center align-items-sm-start d-grid" id="menu">
                    {menuItems.map((menuItem) => {
                        // if (menuItem.LstChildMenu.length ==0)
                        // return (
                        //     <li key={menuItem.MenuId} >
                        //         <Link to={{pathname:menuItem.MenuName}} >
                        //         { <img src={`/images/${menuItem.MenuId!==1 ?menuItem.MenuImageUrl:`home.svg`}`} />}
                        //             <span>{menuItem.MenuName}</span>
                        //         </Link>
                        //     </li>)
                        // else
                        return (
                        <li key={menuItem.MenuId}>
                                <a href={`#MenuLevl${menuItem.MenuId}`} data-bs-toggle="collapse" className={`subMenu nav-link align-middle ${(menuItem.LstChildMenu).length > 0 && `dropdown-toggle collapsed`}`} data-bs-autoclose="true" onClick={() => handleMenuClick(menuItem.MenuName)} >
                                    {<img src={`/images/${menuItem.MenuId !== 1 ? menuItem.MenuImageUrl : `home.svg`}`} />}
                                    <span>{menuItem.MenuName}</span>
                                </a>
                                {renderChildMenuItems(menuItem.LstChildMenu, `MenuLevl${menuItem.MenuId}`, menuItem.MenuName)}
                            </li>)
                    })}
                </ul>
                <hr />
                <ul className="nav nav-pills flex-column">
                    <li className='w-100' onClick={CollapseSideBar}><a className="nav-link" id="sidebarCollapse"><span>Collapse Side Bar</span></a></li>
                </ul>
            </div>
        </nav>
    );
};


export const ReactProCustomSidebar = () => {
    const defaultEntityIds={
        AssetId:0,
        PortfolioId:0,
        InvestorId:0,
        UniverseId:0,
        MarketdataId:0
    }
    // updated side bar 
    const { instance, accounts } = useMsal();
    const Gstate = useSelector(state => state);
    const activeMenuID= Gstate.common.activeMenuID;
    const activeSubMenuID =Gstate.common.activeSubMenuID;
    const userId = Gstate.common.userDetails.UserId;
    const tenantId = Gstate.common.userDetails.TenantId;
    const Token = Gstate.authorizationData?.token;
    const entities=Gstate.common.selectedEntities;
    const LeftDataItems = useSelector(state => state.leftMenu.leftMenuItems) || [];
    const currentAsset = useSelector(state => state.asset.asset) || {};
    const currentPortfolio = useSelector(state => state.portfolio.portfolio) || {};
    const currentMarket = useSelector(state => state.Marketdata.Marketdatadetails) || {}
    const currentUniverse = useSelector(state => state.AnalyticsReporting.memberList) || {}



    const CurrentThirdPartyData = useSelector(state => state.ThirdPartyData.ThirdPartyDetails) || {}
    const {notifications, setShowNotificationDrawer}=useNotification()

    
    const currentInvestor=useSelector(state=>state.Contacts.ContactsHeader) || {};

    const [collapsed, setCollapsed] = useState(false);
    const [menuData, setMenuData] = useState(LeftDataItems);
    const [knowledgeBase, setKnowledgeBase] = useState(false);
    const [menuHover, setMenuHover] = useState(false);
    const dispatch = useDispatch();
    const history = useNavigate();
    const [defaultEntities,setdefaultEntities]=useState(entities);
    const AssetID =  currentAsset.AssetId || defaultEntities?.AssetId|| 34172;
    const portfolioID=currentPortfolio.PortfolioId || 2537; 
    const MarketIndexId = currentMarket.MarketIndexId || defaultEntities.MarketdataId || 25;
    const ContactId = currentInvestor.ContactId || defaultEntities.InvestorId || 810;
    const UniverseID = currentUniverse.UniverseId || defaultEntities.UniverseId || 810;


    const thirdPartyEntity = CurrentThirdPartyData.CustomEntityId || defaultEntities.ThirdPartyDataId || 1;
    
    
    const navigate = useNavigate();
    const [hasAccess, setHasAccess] = useState(false);
    const checkAccess = async() => {
      try{
        const res = await sbaAxios({url:checkNotificationAccess});
        setHasAccess(res);
      }
      catch(e){
        setHasAccess(false);
      }
    }
    useEffect(()=>{
      checkAccess();
    },[]);

    const getAdminAccessStatus = async () => {
        try{
            const response = await sbaAxios(
                { url: `${getUserPageAccess}?keyName=AdminPermissionAccess` }
            );
            return response
        }
        catch(e){
            return false;
        }
    };

    const handleLogOut = () => {

        instance.logoutRedirect({
            postLogoutRedirectUri: "/",
        });
        sessionStorage.clear();
        localStorage.clear();
    };

    const OpenHelpWindow=()=>{
        const pathSegments = window.location.pathname.split("/");
        const model = pathSegments[1];
        const url = `${UrlPath.Help}?section=${model}`;
        window.open(url,'_blank');
    }

    const getKnowledgeBaseSetting = async() => {
        try{
            const response = await sbaAxios({ url: `${getCustomSettings}1028` });
            if(response){
                const parsedResponse = JSON.parse(response.CustomSettingsValue);
                setKnowledgeBase(parsedResponse.knowledgeBase);
                setMenuHover(parsedResponse.menuHover)
            }
        }
        catch(e){
            setKnowledgeBase(false);
            setMenuHover(false);
        }
    }
    useEffect(()=>{
        getKnowledgeBaseSetting();
    },[menuData])

    useEffect(()=>{
        if(menuHover){
            hoverEventHandler(true)
        }
    },[menuHover])
    
    useEffect(()=>{
       setdefaultEntities(entities || defaultEntityIds );
    },[entities]);
    useEffect(()=>{
        document.addEventListener('keydown', handleKeyPress);
    },[]);
    const handleKeyPress=(event)=>{
        event = event || window.event;
        if (event.altKey && event.keyCode == 88) {
            TogglesideBar();
        }
    }
    const [receivedValues, setReceivedValues] = useState(false);
    const [retryCount, setRetryCount] = useState(0);

    useEffect(() => {
        // Check if userId, tenantId, and Token are defined
        if (userId !== undefined && tenantId !== undefined && Token !== undefined) {
            setReceivedValues(true);  // Set the flag to true when values are received
            dispatch(getLeftMenuSection(tenantId, userId, Token));
        }
    }, [userId, tenantId, Token, dispatch]);

    useEffect(() => {
        // Update menu data when LeftDataItems or collapsed changes
        setMenuData(LeftDataItems);
    }, [LeftDataItems]);

    useEffect(() => {
        // Check if values are not received within 3 seconds
        const timeoutId = setTimeout(() => {
            if (!receivedValues && retryCount < 3) {
                // Retry fetching the values (adjust conditions and retryCount limit as needed)
                setRetryCount(retryCount + 1);
               
            } else if (!receivedValues) {
                // Handle the case where values are not received after multiple attempts
                
            }
        }, 3000);  // 3000 milliseconds (3 seconds)

        // Cleanup the timeout when the component unmounts or values are received
        return () => clearTimeout(timeoutId);
    }, [receivedValues, retryCount]);
    //useEffect(() => {
    //    if (userId !== undefined && tenantId !== undefined && Token !== undefined)
    //        dispatch(getLeftMenuSection(tenantId, userId, Token));
    //}, [userId]);
    //useEffect(() => {
    //    setMenuData(LeftDataItems);
    //}, [LeftDataItems,collapsed]);
  
    useEffect(()=>{
        // if(activeMenuID)
        // {
        //     const newMenuData = menuData.map((item) => {
        //         if (item.MenuId == activeMenuID) {
        //             if(activeSubMenuID)
        //             {
        //                 item.LstChildMenu = item.LstChildMenu.map((Child) => {
        //                     if (Child.MenuId == activeSubMenuID) {
        //                         Child.IsEnabled = false;
        //                         return { ...Child };
        //                     } else {
        //                         Child.IsEnabled = true;
        //                         return { ...Child };
        //                     }
        //                 });
        //             }
        //             item.IsEnabled = false;
        //             return { ...item };
        //         } else {
        //             item.IsEnabled = true;
        //             return item;
        //         }
        //     });
        // setMenuData(newMenuData);
        // }
    },[activeMenuID,activeSubMenuID]);

    const assetMenuID=2;
    const investorMenuID=4;
    const analyticsReportingMenuID=6;
    const listMenuID=35;
    const investorDetails=30;
    const marketDataMenuID=40;
    const peerAnalyticsID=12003;
    const proformaConstructionID=47;
    const portfolioValuationID=26;
    const portfolioMenuId=3;
    

    const TogglesideBar = () => {
        const Expanded = $('aside.ps-collapsed').length > 0;
        if (!Expanded) {
            $('#main-content').css('margin-left', '85px');
        }
        else {
            $('#main-content').css('margin-left', '270px');
        }
        setCollapsed((value) => !value);
        // setMenuData((value) =>
        //     value.map((item) => {
        //         return { ...item, IsEnabled: true };
        //     })
        // );
    };
    const updateOpenState = (e, menuId) => {
        $("div.ps-submenu-content div.ps-submenu-content").css("display", "none");
        $("div.ps-submenu-content").css("display", "none");
        $("div.ps-submenu-content div.ps-submenu-content ,div.ps-submenu-content li > * ").removeClass("ps-open");
        const newMenuData = menuData.map((item) => {
            if (item.MenuId == menuId) {
                item.IsEnabled = !item.IsEnabled;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsEnabled = true;
                    return sub;
                })
                return { ...item };
            } else {
                // item.IsVisible = true;
                item.IsEnabled = true;
                return item;
            }
        });
        //dispatch(setActiveSubMenu(null,null));
        dispatch(setActiveMenu(null));
        setMenuData(val=>newMenuData);
    };

    const updateChildOpenState = (e, mainMenuId, childMenuId) => {
        // $("div.ps-submenu-content div.ps-submenu-content").css("display", "none");
        // $("div.ps-submenu-content div.ps-submenu-content ").removeClass("ps-open");
        const newMenuData = menuData.map((item) => {
            if (item.MenuId == mainMenuId) {
                item.LstChildMenu = item.LstChildMenu.map((Child) => {
                    if (Child.MenuId == childMenuId) {
                        Child.IsEnabled = !Child.IsEnabled;
                        return { ...Child };
                    } else {
                        Child.IsEnabled = true;
                        return { ...Child };
                    }
                });
                item.IsEnabled = false;
                return { ...item };
            } else {
                item.IsEnabled = true;
                return item;
            }
        });
        dispatch(setActiveSubMenu(null,null));
        setMenuData(val=> newMenuData);
    };
    const navigateMainMenu=(mainMenu, nav)=>{
        const newMenuData = menuData.map((item) => {
            if (item.MenuId == mainMenu.MenuId) {
                item.IsHighlighted = true;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsHighlighted = false;
                    sub.LstChildMenu=  sub.LstChildMenu.map(subChild=>{
                        subChild.IsHighlighted = false;
                        subChild.IsEnabled=true;
                        return subChild
                    })
                    return sub;
                })
                return { ...item };
            } else {
                item.IsHighlighted = false;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsHighlighted = false;
                    sub.LstChildMenu=  sub.LstChildMenu.map(subChild=>{
                        subChild.IsHighlighted = false;
                        subChild.IsEnabled=true;
                        return subChild
                    })
                    return sub;
                })
                return item;
            }
        });
        setMenuData(val=>newMenuData);
        if(nav){
            history(`${mainMenu.MenuName}`);
        }
    };
    const navigateSubMenu=(Url,mainMenu,childMenu)=>{
        const newMenuData = menuData.map((item) => {
            if (item.MenuId == mainMenu.MenuId) {
                item.IsHighlighted = true;
                item.IsEnabled=false;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsHighlighted = false;
                    sub.IsEnabled=true;
                    if (sub.MenuId == childMenu.MenuId) {
                        sub.IsHighlighted = true;
                        sub.IsEnabled=false;
                    }
                    sub.LstChildMenu =  sub.LstChildMenu.map(subChild=>{
                        subChild.IsHighlighted = false;
                        subChild.IsEnabled=true;
                        return subChild
                    });
                    return sub;
                })
                return { ...item };
            } else {
                item.IsEnabled=true;
                item.IsHighlighted = false;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.LstChildMenu=  sub.LstChildMenu.map(subChild=>{
                        subChild.IsHighlighted = false;
                        subChild.IsEnabled=true;
                        return subChild
                    })
                    sub.IsEnabled=true;
                    sub.IsHighlighted = false;
                    return sub;
                })
                return item;
            }
        });
        setMenuData(val=>newMenuData);
        history(`${Url}`);
    };
    const navigateSubChildMenu=(Url,mainMenu,childMenu,subChildMenu)=>{
        const newMenuData = menuData.map((item) => {
            if (item.MenuId == mainMenu.MenuId) {
                item.IsHighlighted = true;
                item.IsEnabled=false;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsHighlighted = false;
                    sub.IsEnabled=true;
                    if (sub.MenuId == childMenu.MenuId) {
                        sub.IsHighlighted = true;
                        sub.IsEnabled=false;
                    }
                    sub.LstChildMenu=  sub.LstChildMenu.map(subChild=>{
                        if (subChild.MenuId == subChildMenu.MenuId) {
                        subChild.IsHighlighted = true;
                        subChild.IsEnabled=false;
                        }
                        else {
                            subChild.IsHighlighted = false;
                            subChild.IsEnabled=true;
                            
                        }
                        return subChild
                    })
                    return sub;
                })
                return { ...item };
            } else {
                item.IsEnabled=true;
                item.IsHighlighted = false;
                item.LstChildMenu = item.LstChildMenu.map(sub => {
                    sub.IsEnabled=true;
                    sub.IsHighlighted = false;
                    return sub;
                })
                return item;
            }
        });
        setMenuData(val=>newMenuData);
        history(`${Url}`);
    }
    const handleMenuClick = (event, index) => {
        event.preventDefault();
    };
    const hoverEventHandler = (collapse) =>{
        const Expanded = $('aside.ps-collapsed').length > 0;
        if (collapse) {
            $('#main-content').css('margin-left', '85px');
        }
        else {
            $('#main-content').css('margin-left', '270px');
        }
        setCollapsed(collapse);
    }

    const handleMouseHover = (collapse) => {
        if(menuHover){
            hoverEventHandler(collapse);
        }
    };

    const handleMenuClickWithAccess = async (mainMenu) => {
        if (mainMenu.MenuName === "Admin") {
            let hasAdminAccess = await getAdminAccessStatus(); // Wait for API response
            console.log('has admin access : ', hasAdminAccess)
            if (!hasAdminAccess) {
                navigateMainMenu(mainMenu, false);
                return;
            }

            navigateMainMenu(mainMenu, true);
            history(`${mainMenu.MenuName}`); // Navigate manually since we prevented default
        } else {
            navigateMainMenu(mainMenu, true);
        }
    }

    return (
        <>
            <div
                className="sidebar"
                id="sidebar"
                style={{ display: "flex", height: "100%", minHeight: "100vh" }}
                onMouseEnter={()=>handleMouseHover(false)}
                onMouseLeave={()=>handleMouseHover(true)}
            >
                <Sidebar backgroundColor="#2D475C" collapsed={collapsed} width="270px" >
                    <Link to={"/"} style={{textDecoration:'none',color:"white"}}><div class="sidebar-header d-flex mx-auto my-auto">
                        <h3 className="m-0 hoverHand" style={{fontWeight:'normal'}}>
                            <img src={AESLogo} alt="" className='me-3' />
                            ASSET EDGE
                        </h3>
                        <strong >
                            <img src={AESLogo} />
                        </strong>
                    </div>
                    </Link>
                    <Menu  className='mb-4'
                    //  renderExpandIcon={()=>{return <span></span>}}
                     >
                        {menuData.map((mainMenu) => {
                            if (mainMenu.LstChildMenu.length > 0)
                                return (
                                  <SubMenu
                                    label={
                                    <Link  
                                        to={`${mainMenu.MenuName}`} 
                                        onClick={async (event) => { 
                                            event.preventDefault();
                                            await handleMenuClickWithAccess(mainMenu);
                                          }}
                                    >{mainMenu.MenuName}</Link>}
                                    icon={
                                      <>
                                        <img
                                          src={`/images/${mainMenu.MenuImageUrl}`}
                                          alt={"..."}
                                          onClick={async(event) => { 
                                            await handleMenuClickWithAccess(mainMenu);
                                          }}
                                        />
                                      </>
                                    }
                                    key={mainMenu.MenuId}
                                    open={!mainMenu.IsEnabled}
                                    onOpenChange={(e) => 
                                        // {}
                                      updateOpenState(e, mainMenu.MenuId)
                                    }
                                    // component={<Link to={`${mainMenu.MenuName}`}/>}
                                    active={mainMenu.IsHighlighted}
                                    onClick={(e)=>{handleMenuClick(e)}}
                                    // suffix={<button className='p-sm-btn' onClick={(e)=>{updateOpenState(e, mainMenu.MenuId)}}>{!mainMenu.IsEnabled ? '' : '>'}</button> }
                                    
                                    >
                                    {mainMenu.LstChildMenu.map((childMenu) => {
                                      let childUrl = `${childMenu.MenuUrl}`;
                                        if (mainMenu.MenuId === assetMenuID) {
                                            childUrl = `${childMenu.MenuUrl}/${AssetID}`;
                                        }
                                        else if (mainMenu.MenuId===portfolioMenuId && childMenu.MenuId !== portfolioValuationID)
                                        {
                                            if(childMenu.MenuName==="Liquidity")
                                           
                                                childUrl = `${childMenu.MenuUrl}`;
                                            
                                           else
                                            childUrl = `${childMenu.MenuUrl}/${portfolioID}`;
                                            
                                        }
                                        else if (mainMenu.MenuId === investorMenuID ) 
                                        {
                                            if (childMenu.MenuId === investorDetails) {
                                                childUrl = `${childMenu.MenuUrl}/${ContactId}`;
                                            }
                                        } else if (mainMenu.MenuId === portfolioMenuId && childMenu.MenuId=== portfolioValuationID) {
                                            childUrl = `${childMenu.MenuUrl}/${AssetID}`;

                                        }
                                      if (childMenu.LstChildMenu.length > 0)
                                        return (
                                          <SubMenu
                                            key={childMenu.MenuId}
                                            // component={
                                            //   <Link to={`${childUrl}`} 
                                            //   onClick={()=>{ navigateSubMenu(childUrl ,mainMenu,childMenu)}}
                                            //   />
                                            // }
                                           
                                            label={<Link  to={`${childUrl}`}  onClick={()=>{ navigateSubMenu(childUrl ,mainMenu,childMenu)}}>{childMenu.MenuName}</Link>}
                                            open={!childMenu.IsEnabled}
                                            onOpenChange={(e) =>
                                              updateChildOpenState(
                                                e,
                                                mainMenu.MenuId,
                                                childMenu.MenuId
                                              )
                                            }
                                            active={childMenu.IsHighlighted}
                                            onClick={(e)=>{handleMenuClick(e)}}
                                              >
                                                {childMenu.LstChildMenu.map((subChild) => {
                                                    let subChildUrl = subChild.MenuUrl;
                                                    if (mainMenu.MenuId === assetMenuID) {
                                                        subChildUrl = `${subChild.MenuUrl}/${AssetID}`;
                                                    } else if (
                                                        mainMenu.MenuId === analyticsReportingMenuID &&
                                                        subChild.MenuParentId === marketDataMenuID
                                                    ) {
                                                        subChildUrl = `${subChild.MenuUrl}/${MarketIndexId}`;
                                                    } else if (
                                                        mainMenu.MenuId === analyticsReportingMenuID &&
                                                        subChild.MenuParentId === peerAnalyticsID &&
                                                        subChild.MenuId !== proformaConstructionID
                                                    ) {
                                                        subChildUrl = `${subChild.MenuUrl}/${UniverseID}`;
                                                    }
                                                    else if ((childMenu.MenuName == "Third Party Data" ||  childMenu.MenuName == "Client Composite")  && (subChild.MenuName == "Analytics" || subChild.MenuName == "Details")) {
                                                        subChildUrl = `${subChild.MenuUrl}/${thirdPartyEntity}`;
                                                    }
                                                    return (
                                                        <MenuItem
                                                            key={subChild.MenuId}
                                                            active={subChild.IsHighlighted}
                                                            component={
                                                                <Link
                                                                    to={subChildUrl}
                                                                    onClick={() => {
                                                                        navigateSubChildMenu(subChildUrl, mainMenu, childMenu, subChild);
                                                                    }}
                                                                >
                                                                    {subChild.MenuName}
                                                                </Link>
                                                            }
                                                        >
                                                            {subChild.MenuName}
                                                        </MenuItem>
                                                    );
                                                })}
                                            </SubMenu>
                                          );
                                      else
                                        return (
                                          <MenuItem
                                          component={
                                                <Link to={childUrl} onClick={()=>{ navigateSubMenu(childUrl ,mainMenu,childMenu)}}>{childMenu.MenuName}</Link>
                                            }
                                            active={childMenu.IsHighlighted}
                                                    // label={<></>}
                                            key={childMenu.MenuId}
                                          >
                                            {childMenu.MenuName}
                                          </MenuItem>
                                        );
                                    })}
                                  </SubMenu>
                                );
                            else
                                return (
                                    <MenuItem
                                    label={
                                    <Link 
                                        to={mainMenu.MenuName} 
                                        onClick={async (event) => { 
                                            event.preventDefault();
                                            await handleMenuClickWithAccess(mainMenu);
                                          }}
                                    >{mainMenu.MenuName}</Link>}
                                    icon={
                                      <>
                                        <img
                                          src={`/images/${mainMenu.MenuImageUrl}`}
                                          alt={"..."}
                                          onClick={async (event) => { 
                                            await handleMenuClickWithAccess(mainMenu);
                                          }}
                                        />
                                      </>
                                    }
                                    key={mainMenu.MenuId}
                                    open={!mainMenu.IsEnabled}
                                    // component={ <span onClick={()=>{ navigateMainMenu(mainMenu)}}>{mainMenu.MenuName}</span>}
                                    active={mainMenu.IsHighlighted}
                                    onClick={async (event) => { 
                                        await handleMenuClickWithAccess(mainMenu);
                                      }}
                                    >
                                        {mainMenu.MenuName}
                                    </MenuItem>
                                );
                        })}
                        {/* {knowledgeBase &&
                        <>
                        <MenuItem icon={<i className="fa-solid fa-question"></i>} onClick={OpenHelpWindow}>Help</MenuItem>
                        <MenuItem icon={<i className="fa-solid fa-gear"></i>} onClick={()=>{navigate("/Settings")}}>User Preferences</MenuItem>
                        <MenuItem icon={<i className="fa-solid fa-power-off"></i>} onClick={handleLogOut}>Sign Out</MenuItem>
                        </>
                        } */}
                       
                    </Menu>
                    <Menu className='mt-auto'>
                    {!menuHover &&
                        <MenuItem
                        icon={
                            <>
                                <img src={collapseSVG} className='sb-collapse' />
                            </>
                        }
                        style={{ borderTop: "1px solid #fff" }}
                        onClick={TogglesideBar}
                        title={`Shortcut Alt-X to ${collapsed? 'expand' : 'collapse'} `}

                        >
                            Collapse Side Bar
                        </MenuItem>} 
                        {knowledgeBase &&
                        <>
                              {hasAccess?
                              <MenuItem
                              icon={
                                  <>
                                  <div className='position-relative'>
                                  <img src={"/images/Notification_icon.svg"} />
                                  {collapsed && notifications.length > 0 && (
                                      <Badge
                                          bg="danger"
                                          text="dark"
                                          className="text-center border border-light text-white rounded-circle position-absolute"
                                      >
                                          {notifications.length}
                                      </Badge>
                                  )}
  
                                  </div>
                                
                              </>                            
                              }
                              suffix={
                                  notifications.length>0 &&  <Badge bg="danger" text="dark"  className='text-center border border-light text-white rounded-circle'>
                                   {notifications.length}
                                </Badge>}
                              onClick={()=>{setShowNotificationDrawer(val=>true)}}
                              className='userSettings'
  
                          >
                             { "Notification"}
                          </MenuItem> :null}
                        <MenuItem
                            icon={
                                <>
                                <img src={help}/>
                                </>
                            }
                            style={{borderTop:menuHover?"1px solid #fff":""}}
                            onClick={()=>{  OpenHelpWindow()  }}
                            className='userSettings'

                        >
                            Help
                        </MenuItem> 
                        <MenuItem
                            icon={
                                <>
                                    <img src={userSVG} 
                                    // className='sb-collapse'
                                     />
                                </>
                            }
                            onClick={()=>{history('/Settings')}}
                            className='userSettings'

                        >
                           { accounts[0]?.name || "Profile"}
                        </MenuItem> 
                        <MenuItem
                            icon={
                                <>
                                    <img src={logout} 
                                     />
                                </>
                            }
                            onClick={()=>{handleLogOut()}}
                            className='userSettings'

                        >
                           Logout
                        </MenuItem>
                        </>}  
                    </Menu>
                </Sidebar>
            </div>
        </>
    );
}

